import  { httpRequest, httpRequestUpload, baseUrl }  from './http';
//基础
export const requestUrl = baseUrl;
//登录接口
export const requestLogin = params => { return httpRequest('post','index/login',params,'json')};
//注册接口
export const requestRegister = params => { return httpRequest('post','index/register',params,'json')};
//注销接口
// export const requestLogout = params => { return httpRequest('post','index/logout',params,'json')};
//修改密码
export const requestUpdatePwd = params => { return httpRequest('post','server/ykhe004/changePwd',params,'json')};
//登录验证码
export const requestMsgloginCode = params => { return httpRequest('get','index/msgCode/login',params,'')};
//发送注册验证码
export const requestMsgRegisterCode = params => { return httpRequest('GET','index/msgCode/register',params,'') };
//发送修改验证码
export const requestMsgCode = params => { return httpRequest('GET','index/msgCode/password',params,'') };
//找回密码
export const requestResetPassword = params => { return httpRequest('post','index/resetPassword',params,'') };
//重置密码
export const requestChangePassword = params => { return httpRequest('post','/server/ykhe009/reset',params,'') };
//上传接口
export const requestUploadFile =  httpRequestUpload('server/videos/upload');

/**
 * 权限模块
 * @param params
 * @returns {AxiosPromise}
 */
//左侧menu权限
export const requestGetMenus = params => { return httpRequest('get','server/ykhe005/loadUserMenu',params,'')};
//获取所有菜单列表
export const requestAllMenu = params => { return httpRequest('get','server/ykhe005/treeList',params,'')};
//删除菜单
export const requestDeleteMenu = params => { return httpRequest('get','server/ykhe005/delete',params,'')};
//查询菜单详情
export const requestMenuInfo = params => { return httpRequest('get','server/ykhe005/info',params,'')};
//添加菜单
export const requestSaveMenu = params => { return httpRequest('post','server/ykhe005/save',params,'json')};
//获取所有角色列表
export const requestAllRole = params => { return httpRequest('get','server/ykhe003/list',params,'')};
//删除角色
export const requestDeleteRole = params => { return httpRequest('get','server/ykhe003/delete',params,'')};
//查询角色详情
export const requestRoleInfo = params => { return httpRequest('get','server/ykhe003/info',params,'')};
//添加角色
export const requestSaveRole = params => { return httpRequest('post','server/ykhe003/save',params,'json')};


//查询用户列表
export const requestSearchUser = params => { return httpRequest('post','server/ykhe004/page',params,'')};
//删除用户
export const requestDeleteUser = params => { return httpRequest('get','server/ykhe004/delete',params,'')};
//查询用户详情
export const requestUserInfo = params => { return httpRequest('get','server/ykhe004/info',params,'')};
//添加用户
export const requestSaveUser = params => { return httpRequest('post','server/ykhe004/save',params,'json')};

/*
 * *数据字典模块
 */
//删除数据字典
export const requestDeleteDataDic = params => { return httpRequest('get','server/ykhe002/delete',params,'')};
//添加数据字典
export const requestSaveDataDic = params => { return httpRequest('post','server/ykhe002/save',params,'json')};
//获取数据字典列表
export const requestFindDataDicList = params => { return httpRequest('post','server/ykhe002/list',params,'')};
//获取全部数据字典类型列表
export const requestFindDataDicTypeAll = params => { return httpRequest('get','server/ykhe001/list',params,'')};
//添加数据字典类型
export const requestSaveDataDicType = params => { return httpRequest('post','server/ykhe001/save',params,'json')};
//删除数据字典类型
export const requestDeleteDataDicType = params => { return httpRequest('get','server/ykhe001/delete',params,'')};
//根据name查询字典
export const requestDataDicListByNames = params => { return httpRequest('post','server/ykhe002/listByNames',params,'')};

/*
 * *学院信息
 */
//查询列表
export const requestPage006 = params => { return httpRequest('get','server/ykhe006/page',params,'')};
//查询列表
export const requestList006 = params => { return httpRequest('get','server/ykhe006/list',params,'')};
//删除
export const requestDelete006 = params => { return httpRequest('get','server/ykhe006/delete',params,'')};
//查询详情
export const requestInfo006 = params => { return httpRequest('get','server/ykhe006/info',params,'')};
//添加
export const requestSave006 = params => { return httpRequest('post','server/ykhe006/save',params,'json')};
//发送短信
export const requestSend006 = params => { return httpRequest('get','server/ykhe006/send',params,'')};

/*
 * *学员信息
 */
//查询列表
export const requestPage009 = params => { return httpRequest('get','server/ykhe009/page',params,'')};
//删除
export const requestDelete009 = params => { return httpRequest('get','server/ykhe009/delete',params,'')};
//查询详情
export const requestInfo009 = params => { return httpRequest('get','server/ykhe009/info',params,'')};
//查询详情
export const requestInfobyclass009 = params => { return httpRequest('get','server/ykhe009/infoByCard',params,'')};
//添加
export const requestSave009 = params => { return httpRequest('post','server/ykhe009/save',params,'json')};
//未报名查询
export const request009unEnter = params => { return httpRequest('post','server/ykhe009/unEnter',params,'')};

/*
 * *班级信息
 */
//查询列表
export const requestPage008 = params => { return httpRequest('get','server/ykhe008/page',params,'')};
//查询列表
export const requestList008 = params => { return httpRequest('get','server/ykhe008/list',params,'')};
//删除
export const requestDelete008 = params => { return httpRequest('get','server/ykhe008/delete',params,'')};
//查询详情
export const requestInfo008 = params => { return httpRequest('get','server/ykhe008/info',params,'')};
//添加
export const requestSave008 = params => { return httpRequest('post','server/ykhe008/save',params,'json')};
//查询treeList列表
export const requestTressList008 = params => { return httpRequest('get','/server/ykhe008/treeList',params,'')};



/*
 * *发票信息
 */
//查询列表
export const requestPage010 = params => { return httpRequest('get','server/ykhe010/page',params,'')};
//删除
export const requestDelete010 = params => { return httpRequest('get','server/ykhe010/delete',params,'')};
//查询详情
export const requestInfo010 = params => { return httpRequest('get','server/ykhe010/info',params,'')};
//添加
export const requestSave010 = params => { return httpRequest('post','server/ykhe010/save',params,'json')};
//添加
export const requestInvoice010 = params => { return httpRequest('post','server/ykhe010/invoice',params,'')};
//导出
export const requestPage010export = params => { return httpRequest('get','/server/ykhe010/export',params,'')};

/*
 * *课件信息
 */
//查询列表
export const requestPage011 = params => { return httpRequest('get','server/ykhe011/page',params,'')};
//删除
export const requestDelete011 = params => { return httpRequest('get','server/ykhe011/delete',params,'')};
//查询详情
export const requestInfo011 = params => { return httpRequest('get','server/ykhe011/info',params,'')};
//添加
export const requestSave011 = params => { return httpRequest('post','server/ykhe011/save',params,'json')};

/*
 * *二级公司信息
 */
//查询列表
export const requestPage012 = params => { return httpRequest('get','server/ykhe012/page',params,'')};
//查询列表
export const requestList012 = params => { return httpRequest('get','server/ykhe012/list',params,'')};
//删除
export const requestDelete012 = params => { return httpRequest('get','server/ykhe012/delete',params,'')};
//查询详情
export const requestInfo012 = params => { return httpRequest('get','server/ykhe012/info',params,'')};
//添加
export const requestSave012 = params => { return httpRequest('post','server/ykhe012/save',params,'json')};

/**
 * 学习记录查询
 */
export const requestPage013 = params =>{return httpRequest('get','server/ykhe013/page',params,'')};
//查询详情
export const requestInfo013 = params => { return httpRequest('get','server/ykhe013/info',params,'')};
//导出
export const requestExport013 = params => { return httpRequest('get','server/ykhe013/export',params,'')};

/**
 * 督导记录查询
 */
export const requestPage014 = params =>{return httpRequest('get','server/ykhe014/page',params,'')};
//查询详情
export const requestInfo014 = params => { return httpRequest('get','server/ykhe014/info',params,'')};
//添加
export const requestSave014 = params => { return httpRequest('post','server/ykhe014/save',params,'json')};
//删除
export const requestDelete014 = params => { return httpRequest('get','server/ykhe014/delete',params,'')};
//添加
export const requestsaveBatch014 = params => { return httpRequest('get','server/ykhe014/saveBatch',params,'')};

/*
 * *考试信息
 */
//查询列表
export const requestPage015 = params => { return httpRequest('get','server/ykhe015/page',params,'')};
//删除
export const requestDelete015 = params => { return httpRequest('get','server/ykhe015/delete',params,'')};
//查询详情
export const requestInfo015 = params => { return httpRequest('get','server/ykhe015/info',params,'')};
//添加
export const requestSave015 = params => { return httpRequest('post','server/ykhe015/save',params,'json')};
//批量发布
export const requestpublish015 = params => { return httpRequest('get','server/ykhe015/publish',params,'')};
//评分
export const requestmark015 = params => { return httpRequest('post','server/ykhe015/mark',params,'json')};

/*
 * *班级学员信息
 */
//查询列表
export const requestPage016 = params => { return httpRequest('get','server/ykhe016/page',params,'')};
//删除
export const requestDelete016 = params => { return httpRequest('get','server/ykhe016/delete',params,'')};
//查询详情
export const requestInfo016 = params => { return httpRequest('get','server/ykhe016/info',params,'')};
//添加
export const requestSave016 = params => { return httpRequest('post','server/ykhe016/save',params,'json')};
//导入
export const requestupload016 = httpRequestUpload('server/ykhe016/upload');
//导出
export const requestPage016export = params => { return httpRequest('get','/server/ykhe016/export',params,'')};
//批量添加
export const request016saveBatch = params => { return httpRequest('post','/server/ykhe016/saveBatch',params,'json')};
//开通学习
export const requestKtxx016 = params => { return httpRequest('get','server/ykhe016/ktxx',params,'')};


/*
 * *班级课程信息
 */
//查询列表
export const requestPage017 = params => { return httpRequest('get','server/ykhe017/page',params,'')};
//查询列表
export const requestList017 = params => { return httpRequest('get','server/ykhe017/list',params,'')};
//查询列表
export const requestMyList017 = params => { return httpRequest('get','server/ykhe017/myList',params,'')};
//删除
export const requestDelete017 = params => { return httpRequest('get','server/ykhe017/delete',params,'')};
//查询详情
export const requestInfo017 = params => { return httpRequest('get','server/ykhe017/info',params,'')};
//添加
export const requestSave017 = params => { return httpRequest('post','server/ykhe017/save',params,'json')};
//批量添加
export const request017saveBatch = params => { return httpRequest('post','/server/ykhe017/saveBatch',params,'json')};

/*
 * *发布通知信息
 */
//查询列表
export const requestPage018 = params => { return httpRequest('get','server/ykhe018/page',params,'')};
//删除
export const requestDelete018 = params => { return httpRequest('get','server/ykhe018/delete',params,'')};
//查询详情
export const requestInfo018 = params => { return httpRequest('get','server/ykhe018/info',params,'')};
//添加
export const requestSave018 = params => { return httpRequest('post','server/ykhe018/save',params,'json')};

/**
 * 报表统计接口
 */
export const requestPagegrade = params => { return httpRequest('get','/server/reports/grade',params,'')};
export const requestPageclassinfo = params => { return httpRequest('get','/server/reports/classInfo',params,'')};
export const requestPageadress = params => { return httpRequest('get','/server/reports/adress',params,'')};
export const requestPagejob = params => { return httpRequest('get','/server/reports/jobs',params,'')};
export const requestPageunit = params => { return httpRequest('get','/server/reports/unit',params,'')};
export const requestPageuandj = params => { return httpRequest('get','/server/reports/unitAndJobs',params,'')};

/*
 * *岗位名称列表
 */
//查询列表
export const requestPage019 = params => { return httpRequest('get','server/ykhe019/page',params,'')};
//查询列表
export const requestList019 = params => { return httpRequest('get','server/ykhe019/list',params,'')};
//删除
export const requestDelete019 = params => { return httpRequest('get','server/ykhe019/delete',params,'')};
//查询详情
export const requestInfo019 = params => { return httpRequest('get','server/ykhe019/info',params,'')};
//添加
export const requestSave019 = params => { return httpRequest('post','server/ykhe019/save',params,'json')};



/*
 * *消息中心管理
 */
//分页查询消息中心列表
// export const requestPage019 = params => { return httpRequest('get','server/ykhe019/page',params,'')};
// //未读消息数量查询
export const requestUnreadCount019 = params => { return httpRequest('get','/server/reports/unitAndJobs111',params,'')};
// export const unitAndJobs111 = params => { return httpRequest('get','/server/reports/unitAndJobs111',params,'')};


//消息已读（全部已读、选择已读）
// export const requestRead019 = params => { return httpRequest('get','server/ykhe019/read',params,'')};



// WEBPACK FOOTER //
// ./src/api/api.js